'use client';
import { FormGroupStyled } from './form-group.styles';

const FormGroup = FormGroupStyled;

export default FormGroup;
